// Controlled vocabularies for the Consultation module (PROMPT 7)
export const CONSULT_STATUSES = [
  { value: "requested", label: "Requested", tone: "sky" },
  { value: "scheduled", label: "Scheduled", tone: "navy" },
  { value: "confirmed", label: "Confirmed", tone: "navy" },
  { value: "completed", label: "Completed", tone: "green" },
  { value: "no_show", label: "No-show", tone: "red" },
  { value: "rescheduled", label: "Rescheduled", tone: "amber" },
  { value: "cancelled", label: "Cancelled", tone: "gray" },
  { value: "follow_up_needed", label: "Follow-up needed", tone: "amber" },
];

export const MEETING_TYPES = [
  { value: "phone", label: "Phone call" },
  { value: "video", label: "Zoom / Video" },
  { value: "in_person", label: "In person" },
];

export const TIME_ZONES = [
  { value: "America/New_York", label: "Eastern (ET)" },
  { value: "America/Chicago", label: "Central (CT)" },
  { value: "America/Denver", label: "Mountain (MT)" },
  { value: "America/Los_Angeles", label: "Pacific (PT)" },
  { value: "America/Toronto", label: "Toronto" },
  { value: "America/Vancouver", label: "Vancouver" },
];

export const SERVICE_LANES = [
  { value: "sell_home", label: "Selling Mom's Home" },
  { value: "senior_placement", label: "Senior Living Placement" },
  { value: "home_safety", label: "Keep Mom Safe at Home" },
  { value: "move_into_my_home", label: "Move Mom Into My Home" },
  { value: "downsizing", label: "Downsizing & Estate" },
  { value: "home_repairs", label: "Home Repairs" },
  { value: "partner_referral", label: "Partner / Vendor Referral" },
];

export const REVENUE_TYPES = [
  { value: "referral_fee", label: "Referral fee" },
  { value: "commission", label: "Commission" },
  { value: "service_fee", label: "Service fee" },
  { value: "retainer", label: "Retainer" },
  { value: "other", label: "Other" },
];

// Structured 11-question consultation notes template
export const NOTES_TEMPLATE = `1. What made the family reach out today?
- 

2. Who is the loved one needing help?
- 

3. Is the loved one safe right now?
- 

4. What is the biggest pressure?
- 

5. Is there a home/property involved?
- 

6. Is there a care placement need?
- 

7. Is there a downsizing or belongings issue?
- 

8. Is the family considering moving Mama into their home?
- 

9. Who is the decision maker?
- 

10. What is the timeline?
- 

11. What are the next three steps?
- 
`;

export const labelOf = (arr, val) => arr.find((o) => o.value === val)?.label || (val || "");
export const optOf = (arr, val) => arr.find((o) => o.value === val) || null;
